import _get from 'lodash/get';
import dayjs from 'dayjs';

export const sortComparator = (sortColumn, row) => {
  const data = _get(row, [sortColumn, 'data']);
  if (sortColumn === 'Total Earned') {
    const price = parseFloat(data.replace('$', ''));
    return price;
  }
  return data;
};

export const roundToDecimal = (num) => {
  if (!num || isNaN(num)) {
    return 0;
  }
  const decimal = Math.round(num * 100) / 100;
  return decimal.toFixed(2);
};

export const getReadablePSTDate = (date) => {
  return dayjs(date).tz('America/Los_Angeles').format('MMM Do YY');
};
